import RequestsForQuotations from './requests-for-quotations-container';

export default RequestsForQuotations;